import { Component, OnInit } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { SeoService } from '../../service/seo.service';
import { NavigationEnd, Router } from '@angular/router';
import { UrlcanonicaService } from '../../service/urlcanonica.service';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-aviso-de-privacidad',
  templateUrl: './aviso-de-privacidad.component.html',
  styleUrls: ['./aviso-de-privacidad.component.css']
})
export class AvisoDePrivacidadComponent implements OnInit {

  RouteText : any;
  tituloseo: any;
  urlcanonicaseo: any;
  imagenseo: any;
  keywordsseo: any;
  descripcionseo: any;

  constructor(
    private meta: Meta,
    private title: Title,
    private _seoService: SeoService,
    private router: Router,
    private _urlcanonicaservice: UrlcanonicaService
    
  ) {
    
    this.router.events.pipe(filter((event: any) =>  event instanceof NavigationEnd)).subscribe((event: NavigationEnd) => {
      this.RouteText = event;
      this.getSEO(event.url)
    });
    
  }
  
  getSEO(page: string) {
    this._seoService.getSEO(page).subscribe((resp: any) => {
      console.log(resp)
      if (resp != null) {
        this.tituloseo = resp.titulo;
        this.descripcionseo = resp.descripcion;
        this.urlcanonicaseo = resp.urlcanonica;
        this.imagenseo = resp.imagen;
  
        this._urlcanonicaservice.createCanonicalLink();
        this.title.setTitle(this.tituloseo)
        this.meta.updateTag({
          name: 'description',
          content: this.descripcionseo
        })
  
        this.meta.updateTag({
          property: 'twitter:card',
          content: 'summary'
        })
        this.meta.updateTag({
          property: 'twitter:site',
          content: '@fundacionbest'
        })
        this.meta.updateTag({
          property: 'twitter:title',
          content: 'Fundación BEST'
        })
        this.meta.updateTag({
          property: 'twitter:description',
          content: this.descripcionseo
        })
        this.meta.updateTag({
          property: 'twitter:image',
          content: this.imagenseo
        })
  
        this.meta.updateTag({
          property: 'og:url',
          content: 'https://fundacionbest.org.mx/servicios'
        })
        this.meta.updateTag({
          property: 'og:title',
          content: this.tituloseo
        })
        this.meta.updateTag({
          property: 'og:image',
          content: this.imagenseo
        })
        this.meta.updateTag({
          property: 'og:description',
          content: this.descripcionseo
        })
      }
  
    });
  }
  ngOnInit(): void {
  }

}
